import { Injectable } from '@angular/core';

@Injectable()
export class LocalStorageService {

  constructor() { }

  get(key) {
    return JSON.parse(localStorage.getItem(key));
  }

  set(key, data) {
    return localStorage.setItem(key, JSON.stringify(data));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/local-storage/local-storage.service.ts